export default {
  registration: {
    give_mandate: {
      badge_tooltip: "Mandat de gestion accordé",
    },
    invoice: {
      filter: {
        active: "Filtres actifs",
        remove: "Retirer le filtre {name}",
        status: "Filtrer par statut",
      },
      title: ({ plural }) => plural(["Facture", "Factures"]),
      global_totals: ({ plural, named }) =>
        plural([
          `${named("count")} échéance au total sur ce flux (facturée ou non)`,
          `${named("count")} échéances au total sur ce flux (facturées ou non)`,
        ]),
      flow: {
        all: "Tous les flux",
        opco: "OPCO",
        company: "Entreprise",
      },
      emitted: {
        title: ({ plural }) => plural(["Facture émise", "Factures émises"]),
        resend: "Renvoyer la facture",
        resend_reference: "Renvoyer la facture {reference}",
        resend_confirmation: "Êtes-vous sûr de vouloir renvoyer cette facture ?",
        selected: ({ plural, named }) =>
          plural([`${named("count")} facture sélectionnée`, `${named("count")} factures sélectionnées`]),
        export: ({ plural, named }) =>
          plural([`Exporter (${named("count")} facture)`, `Exporter (${named("count")} factures)`]),
        export_selection: ({ plural, named }) =>
          plural([
            `Exporter la sélection (${named("count")} facture)`,
            `Exporter la sélection (${named("count")} factures)`,
          ]),
        deposit_selection: ({ plural, named }) =>
          plural([
            `Déclarer déposée la facture sélectionnée (${named("count")})`,
            `Déclarer déposées les factures sélectionnées (${named("count")})`,
          ]),
        see_error: "Voir les erreurs",
        error_date: "Date de l'erreur : {date}",
        resend_rejection: {
          title: "La facture n'a pas pu être renvoyée",
          reference: "Facture",
          dismiss: "Fermer le message d'erreur de renvoi",
        },
        see_details: "Voir le détail",
        download_pdf: "Télécharger la facture",
        download_completion_certificate: "Télécharger le certificat de réalisation",
        deposit: {
          cancel: "Annuler",
          cancel_deposit: "Annuler le dépôt",
          cancel_deposit_confirmation: "Annuler le dépôt de cette facture ?",
          choose_another_date: "Choisir une autre date",
          form_title: "Modifier la date de dépôt",
          declare_deposit: "Déclarer comme déposée",
          declare_confirm_title: "Êtes-vous sûr de vouloir déclarer cette facture comme déposée ?",
          edit_confirm_title: "Êtes-vous sûr de vouloir modifier la date de dépôt de cette facture ?",
          platform_title: "Dépôt sur la plateforme",
          platform_error_message:
            "L'envoi à l'OPCO a échoué. Si vous avez déposé cette facture directement sur la plateforme de l'OPCO, vous pouvez le déclarer ici.",
          date_updated_success: "Date de dépôt modifiée avec succès !",
          selection_confirm_title: ({ plural, named }) =>
            plural([
              `Déclarer déposée la facture sélectionnée (${named("count")}) ?`,
              `Déclarer déposées les factures sélectionnées (${named("count")}) ?`,
            ]),
          selection_confirm_text: "Seules les factures à déposer seront déclarées déposées, les autres seront ignorées",
          selection_result: "{deposited} et {ignored}",
          selection_deposited: ({ plural, named }) =>
            plural([
              "Aucune facture déclarée déposée",
              `${named("count")} facture déclarée déposée`,
              `${named("count")} factures déclarées déposées`,
            ]),
          selection_ignored: ({ plural, named }) =>
            plural([`${named("count")} facture ignorée`, `${named("count")} factures ignorées`]),
        },
      },
      retry: {
        tooltip: "Relancer la génération du PDF",
        success: "La génération du PDF a été relancée avec succès.",
      },
      credit_note: {
        document_title: "Avoir",
        download_pdf: "Télécharger l'avoir",
        emit: "Émettre un avoir",
        title: "Émission d'un avoir",
        confirm: "Êtes-vous sûr de vouloir émettre cet avoir ?",
        success: "Avoir émis avec succès !",
        type_total: "Avoir total",
        type_partial: "Avoir partiel",
        confirm_irreversible: "Cette action est définitive et ne pourra pas être annulée.",
        pdf_failed: "L'avoir a été créé mais son PDF n'a pas pu être généré.",
        pdf_failed_retry: "Voulez-vous relancer la génération du PDF maintenant ?",
        see_origin_invoice: "Voir la facture d'origine",
        see_origin_invoice_label: "Voir la facture d'origine N°{code}",
      },
      attached_credit_notes: {
        title: ({ plural, named }) =>
          plural([
            `Cette facture a fait l'objet de ${named("count")} avoir`,
            `Cette facture a fait l'objet de ${named("count")} avoirs`,
          ]),
        number: "Avoir N°{number}",
        issued_at: "Émis le {date}",
        reason: "Motif : {reason}",
        see_credit_note: "Voir l'avoir",
        see_credit_note_label: "Voir l'avoir N°{number}",
      },
      schedule: {
        title: ({ plural }) => plural(["Échéance à facturer", "Échéances à facturer"]),
        selected: ({ plural, named }) =>
          plural([`${named("count")} échéance sélectionnée`, `${named("count")} échéances sélectionnées`]),
        total_amount: "Montant total : {amount}",
        cancel_selection: "Annuler la sélection",
        emit: "Émettre les factures",
        export: ({ plural, named }) =>
          plural([`Exporter (${named("count")} échéance)`, `Exporter (${named("count")} échéances)`]),
        export_selection: ({ plural, named }) =>
          plural([
            `Exporter la sélection (${named("count")} échéance)`,
            `Exporter la sélection (${named("count")} échéances)`,
          ]),
        emit_confirmation: ({ plural, named }) =>
          plural([
            `Émettre la facture de l'échéance sélectionnée ?`,
            `Émettre les factures des ${named("count")} échéances sélectionnées ?`,
          ]),
        emit_progress: {
          title: "Émission des factures en cours",
          label: "Factures émises : {done} / {total}",
        },
        rejection: {
          title: ({ plural, named }) =>
            plural([
              `${named("count")} échéance n'a pas pu être mise en file de facturation`,
              `${named("count")} échéances n'ont pas pu être mises en file de facturation`,
            ]),
          reference: "Échéance",
          reason: "Motif",
          dismiss: "Fermer le message des échéances rejetées",
        },
      },
      emit: {
        title: "Émettre les factures",
        cancel: "Annuler",
        confirm: "Émettre les factures",
        summary: {
          line: "Votre sélection comporte {schedules} pour {recipients}, soit un total de {amount}.",
          schedules: ({ plural, named }) => plural([`${named("count")} échéance`, `${named("count")} échéances`]),
          recipients: ({ plural, named }) =>
            plural([`${named("count")} destinataire`, `${named("count")} destinataires`]),
        },
        alerts: {
          title: ({ plural }) => plural(["Alerte à vérifier", "Alertes à vérifier"]),
          show: "Afficher les alertes",
          hide: "Masquer les alertes",
          block_show: "Afficher les alertes de ce destinataire",
        },
        channel: {
          api_opco: "API OPCO",
          platform: "Dépôt plateforme",
          email: "Envoi par e-mail",
          unknown: "Canal inconnu",
          region_label: "Échéances du canal {channel}",
        },
        block_total: "Total TTC : {amount}",
        empty: "Aucune échéance sur ce canal.",
      },
    },
    name: "Nom",
    institution: "Établissement",
    component: "Composante",
    trainingCourse: "Promotion",
    group: "Groupe",
    Contact: "Contact",
    registration_settings: "Paramétrage inscription",
    pedagogicInformations: "Informations pédagogiques",
    fundingInformations: "Informations financières",
    dates: "Dates",
    from_to: "du {from} au {to}",
    hourlyVolume: "Volume horaire",
    hourlyRemoteVolume: ({ named }) => `Dont ${named("volume")} h à distance`,
    hourlyCost: "Coût horaire de la prestation",
    prestationCost: "Montant de la prestation - Net de taxe",
    amount: "Montant",
    modality: ({ plural }) => plural(["Modalité", "Modalités"]),
    in_person: "Présentiel",
    distanciel: "Distanciel",
    remoteVolume: "Dont enseignement à distance",
    degreePrepared: "Diplôme préparé",
    level: "Niveau",
    titleRncp: "Titre RNCP",
    degreeCode: "Code diplôme",
    calendar: "Calendrier",
    program: "Programme",
    apprenticeShipContract: "Contrat d'apprentissage",
    proContract: "Contrat de professionnalisation",
    rate: "Tarif",
    publicAnnualRate: "Coût annuel employeurs publics",
    annualRate: "Coût annuel",
    totalRate: "Coût total",
    hourlyRate: "Tarif horaire",
    followUp: "Suivi du dossier",
    devices: "Dispositifs",
    createdAt: "crée le {date}",
    help: "Aide",
    follow: "Suivi",
    inProgress: "En cours",
    validatedAt: "Validée le {date} par {validator}",
    steps: "Les étapes",
    statistics: "Statistiques",
    generalInformations: "Informations générales",
    civility: "Civilité",
    firstName: "Prénom",
    birthDate: "Date de naissance",
    age: "Âge",
    email: "Email",
    phone: "Téléphone",
    address: "Adresse",
    nationality: "Nationalité",
    male: "M.",
    female: "Mme.",
    years: "ans",
    apprentice: "Apprenti",
    tutor: "Tuteur",
    ufa: "UFA",
    cfa: "CFA",
    map: "Maitre d'apprentissage",
    function: "Fonction",
    contacts: "Contacts",
    previousSituation: "Situation antérieur",
    ineCode: "Code INE",
    preContractSituation: "Situation avant contrat",
    lastDegreeObtained: "Dernier diplôme obtenu",
    title: "Intitulé",
    lastDegreePrepared: "Dernier diplôme préparé",
    lastInstitution: "Dernier établissement",
    uaiCode: "Code UAI",
    department: "Département",
    socialReason: "Raison sociale",
    company: "Entreprise",
    head_office: "Siège social",
    activityCode: "Code d'activité (NAF)",
    totalWorkForce: "Effectif total",
    siret: "SIRET",
    employerType: "Type d'employeur",
    employerSubType: "Sous-type d'employeur",
    idcc: "IDCC",
    opco: "OPCO",
    opcoComparison: {
      title: "Comparaison des données",
      caption: "Comparaison des données OPCO et Studea",
      baseline: "Données OPCO et données Studea",
      empty: "Aucune donnée à comparer",
      label: "Libellé",
      seeDifferences: "Voir les différences",
      level: {
        minor: "Écart mineur",
        strict: "Écart important",
      },
    },
    salaryDetail: {
      empty: "Aucune donnée de rémunération",
    },
    hostCompany: "Entreprise d'accueil",
    administratorCompany: "Siège de l'entreprise",
    training: "Formation",
    startDate: "Date de début",
    endDate: "Date de fin",
    hourlyTrainingVolume: "Nombre d'heures",
    apprenticeMaster: "Maitre d'apprentissage",
    apprenticeMaster2: "Maitre d'apprentissage 2",
    degree: "Diplôme",
    hostCompanyContact: "Contact entreprise d'accueil",
    administratorCompanyContact: "Contact siège entreprise",
    pricePolicyInfo1:
      "Reste à charge uniquement si la prise en charge est inférieure ; la prise en charge plafonnée au tarif, même si elle est supérieure.",
    pricePolicyInfo2:
      "Reste à charge uniquement si la prise en charge est inférieure au tarif ; si supérieure, on applique le tarif en fonction de la prise en charge.",
    pricePolicyInfo3: "Le tarif est aligné sur la prise en charge.",
    signIn: "Créer un compte",
    login: "Se connecter",
    loginInfo: "Authentifiez-vous ou créez un compte pour accéder à la fiche d’inscription",
    loginInfo2: "Authentifiez-vous pour accéder à la fiche d’inscription",
    needAccount: "Je n'ai pas de compte",
    noNeedAccount: "J'ai déjà un compte",
    anApprentice: "Un.e alternant.e",
    aCompany: "Une entreprise",
    iAm: "Je suis",
    createApprenticeAccount: "Créer un compte alternant.e",
    createCompanyAccount: "Créer un compte entreprise",
    accountExist: "Votre e-mail a été reconnu !",
    accountExistSubTitle: "Vous pouvez vous connecter directement à votre compte avec vos identifiants !",
    next: "Suivant",
    prev: "Précédent",
    workInProgress: "À valider",
    valid: "Validé",
    pending: "En cours",
    publicSector: "Secteur public",
    privateSector: "Secteur privé",
    link_copied_success: "Lien copié dans le presse-papier avec succès !",
    status: {
      upcoming: "À venir",
      in_progress: "En cours",
      finalised: "Finalisé",
      break_up: "Rupture",
      cancelled: "Annulé",
    },
    insee_company: {
      title: ({ plural }) => plural(["Entreprise INSEE ", "Entreprises INSEE"]),
      siret: "SIRET",
      activity: "Activité (NAF/APE)",
      details: "Détails (nom, enseigne, adresse)",
      creation: "Création",
      state: "État",
      social_reason: "Raison sociale",
      current: "Établissement courant",
      head_office: "Siège de la société",
      creation_date: "Date de création",
      work_force: "Effectif",
      status: "Statut",
      principal_address: "Adresse principale",
      secondary_address: "Adresse secondaire",
      empty_contact: "Aucun contact n'est renseigné pour cette entreprise",
      undefined_work_force: "Aucune donnée renseignée",
    },
    training_info: {
      search_by_branch: "Recherche par convention collective",
      funding_coverage: "Prise en charge :",
      decree_cost: "Coût décret : ",
      only_different_cost_displayed: "Par défaut, seuls les coûts différents du coût décret sont affichés",
      info_tab: {
        general_info: "Informations générales",
        rncp_sheet: "Fiche RNCP",
        program: "Programme",
        setttings: "Paramétrage inscription",
        matrix: "Matrice UE-Compétence",
        settings: "Paramétrage inscription",
        npec: "NPEC",
        contact: "Contact pour les entreprises",
      },
      general_info: {
        institution_name: "Nom de l'établissement",
        reference: "Référence",
        rncp_number: "Numéro RNCP",
        offical_name: "Nom officiel",
        diplome_type: "Type de diplôme",
        mention: "Nom / mention",
        route: "Parcours",
        diplome_code: "Code diplôme",
        status: "Statut",
        logo: "Logo",
        partner_website_url: "URL du site partenaire",
        link: "Lien",
        work_study_duration: "Durée de l'alternance",
        total_cycle_time: "Durée total du cycle",
        active: "Active",
        archived: "Archivée",
      },
    },
    alert: {
      title: ({ plural }) => plural(["Alerte ", "Alertes"]),
      level: {
        info: "Information",
        warning: "Alerte",
        error: "Erreur",
      },
      active_unactive: "Activer/Désactiver",
      see_more: "Voir plus",
      empty: "Aucune alerte de niveau {level}",
    },
    group_action: {
      see_sheet: "Voir la fiche de pré-inscription",
      see_contract: "Voir le contrat",
      duplicate: {
        title: "Dupliquer la fiche",
        confirmation: {
          title: "Êtes-vous sûr de vouloir dupliquer cette fiche ?",
          subtitle:
            "Une nouvelle fiche sera créée à partir des informations de l'onglet apprenti. La fiche d'origine ne sera pas modifiée.",
        },
        success: "Nouvelle fiche créée avec succès !",
      },
      copy_sheet: "Copier le lien de la fiche de pré-inscription",
      create: "Créer une fiche de pré-inscription",
      cancel: {
        title: "Annuler cette fiche de pré-inscription",
        confirmation: {
          title: "Êtes-vous sûr de vouloir annuler cette fiche ?",
          subtitle:
            'L\'inscription ne sera plus visible depuis le tableau de bord, vous pourrez la restaurer en sélectionnant les fiches "annulées"',
          apprentice_subtitle: "L'inscription ne sera plus visible depuis le tableau de bord.",
        },
        success: "Fiche de pré-inscription annulée avec succès !",
        reset: {
          title: "Réactiver cette fiche de pré-inscription",
          confirmation: {
            title: "Êtes-vous sûr de vouloir réactiver cette fiche ?",
            subtitle: "La fiche sera réactivée et de nouveau visible par les autres utilisateurs",
          },
          success: "Fiche de pré-inscription réactivée avec succès !",
        },
      },
      see_group_detail: "Voir les détails du groupe",
      contact_list: "Liste des contacts",
      delete: {
        confirmation: "Êtes-vous sûr de vouloir supprimer ce groupe ?",
        success: "Groupe supprimé avec succès !",
      },
      download: {
        commitments: "Télécharger le certificat d'engagement",
      },
    },
    dashboard: {
      go_to: "Accéder au tableau de bord de cette formation",
      go_to_institution: "Accéder au tableau de bord de l'établissement",
    },
    creation: {
      alert: {
        title: "Une inscription existe déjà pour cette formation",
        multipleTitle: "Vous avez déjà des inscriptions pour cette formation",
      },
      info: "Pour créer une nouvelle fiche d'inscription, veuillez d'abord saisir les informations du candidat",
      success: ({ named }) =>
        `Fiche de pré-inscription de ${named("firstName")} ${named("lastName")} créée avec succès !`,
    },
    user_not_connected: "Vous devez vous connecter pour accéder à cet espace",
    quote: {
      contract: "Contrat",
      financial: "Financement",
      amount: "Grille des montants",
      edit_cost: "Modifier les coûts",
      subtitle: "Récapitulatif financier du contrat d'apprentissage",
      initial_cost: "Coût initial",
      final_cost: "Coût final",
      modal_alert:
        "Ces modifications affecteront le montant facturé à l'entreprise. Assurez-vous que les montants sont conformes à votre convention.",
      updated_cost: ({ plural, named }) => plural(["1 montant modifié", `${named("number")} montants modifiés`]),
      no_updated_cost: "Aucun montant modifié",
      edit: {
        date: {
          title: "Modifier les dates de la formation (pour ce dossier)",
          success: "Modification des dates de la formation effectuée avec succès !",
        },
        cost: {
          title: "Modifier les montants",
          success: "Montants modifiés avec succès !",
          reset_cost: "Réinitialiser les montants",
          confirmation: "Êtes-vous sûr de vouloir valider ces montants ?",
          reset_confirmation: "Êtes-vous sûr de vouloir réinitialiser ces montants ?",
          reset_success: "Montants réinitialisés avec succès !",
          previous_amount: ({ named }) => `précédemment ${named("amount")}`,
          reference_legend: ({ named }) => `montants issus de la convention/devis envoyée le ${named("date")}`,
        },
      },
      table: {
        columns: {
          trainingCourseCost: "Coût de la formation",
          opcoo: "Prise en charge",
          mandatory_participation: "Participation obligatoire",
          mandatory_participation_tooltip:
            "Part du financement imposée par le dispositif ou le financeur.\n" +
            "Elle s’ajoute, le cas échéant, au reste à charge.\n" +
            "Conformément à l’article L6332-14 du Code du travail, une participation peut être demandée à l’employeur.",
          remaining_cost: "Reste à charge",
          remaining_cost_tooltip:
            "Montant non pris en charge par le financeur.\n" +
            "Il est distinct de la participation obligatoire et dépend des conditions de prise en charge validées par l’OPCO",
        },
      },
      duration: {
        title: "Durée",
      },
      billingStartDate: {
        title: "Date de début",
      },
      billingEndDate: {
        title: "Date de fin",
      },
      caption: {
        title: "* Montants HT – exonération de TVA",
        subtitle: "(art. 261, 4-4° du CGI, activité d'enseignement).",
      },
      title: "Devis",
      verify: "Vérifier le devis",
      cost_historic: "Historique des versions — Tableau financier",
      convention: {
        title: "Convention",
      },
    },
    contact: {
      title: "Un contact",
      success: "Contact ajouté avec succès !",
      info: "Renseignez la personne à contacter dans l'entreprise. Vous pouvez ajouter plusieurs contacts en cas d'absence. Le contact recevra le mail à la validation de l'étape.",
      edit_succes: "Contact modifié avec succès !",
      edit: {
        success: "Contact modifié avec succès !",
        alert: "Ces modifications s'appliquent au compte utilisateur sur l'ensemble de la plateforme.",
      },
      delete: {
        confirmation: "Êtes-vous sûr de vouloir supprimer ce contact ?",
        success: "Contact supprimé avec succès !",
      },
      director: "Dirigeant.e / Signataire",
      temporary: "Contact temporaire",
      interlocutor: "Interlocuteur.rice gestion administrative",
      billing: "Contact facturation",
      attendance: "Contact assiduité",
      gestionnary: "Gestionnaire",
      different_name: "Ce nom apparaîtra sur la convention mais ne crée pas de compte utilisateur.",
      mail_status: {
        waiting: "En attente d’activation",
        send: "Mail envoyé",
        active: "Actif",
      },
      account: {
        already_exist: {
          title: "Ce compte existe déjà",
          subtitle:
            "L'adresse email renseignée est déjà utilisée par un compte (1 mail = 1 utilisateur). Le titulaire du compte peut modifier ses coordonnées sur son espace",
        },
      },
      registration: {
        title: "Contact inscription",
        empty: "Aucun contact inscription renseigné",
      },
      company: {
        title: "Contact entreprise (interlocuteur RH)",
        empty: "Aucun contact entreprise renseigné",
      },
    },
    reminder: {
      title: "Renvoyer la notification lien entreprise",
      confirmation: {
        title: "Êtes-vous sûr de vouloir renvoyer la notification lien entreprise ?",
      },
      send: "Envoyer",
      success: "Notification envoyée avec succès !",
    },
    comment: {
      title: "Commentaires",
      new: "Nouveau",
      unread: ({ plural }) => plural(["Message non lu", "Messages non lus"]),
      actions: ({ plural }) => plural(["Action requise", "Actions requises"]),
      add: "Ajouter un commentaire",
      empty: "Aucun commentaire renseigné",
      action_required: {
        done: "J'ai réalisé cette action",
        doneBy: "Action réalisée par",
        empty: "Action à réaliser",
      },
      delete: {
        success: "Commentaire supprimé avec succès !",
        confirmation: "Êtes-vous sûr de vouloir supprimer ce commentaire ?",
      },
    },
    contractType: {
      apprentice: "Apprenti.e.s",
      pro: "Contrat pro",
    },
    document: {
      cerfa: {
        title: "CERFA",
        notice: "Voir la notice",
      },
      convention: {
        title: "Convention",
      },
      update: {
        success: ({ named }) => `Votre ${named("document")} à été enregistré avec succès !`,
      },
      upload_at: `Déposé le {date}`,
      version: "Version",
      status: {
        correction_requested: "Correction demandée",
        verified: "Vérifié",
        sent: "Envoyé",
        deposited: "Déposé",
        to_send: "À déposer",
        to_be_modified: "Modification à apporter",
        validated: "Validé",
        to_verify: "À vérifier",
      },
      actual_version: "Version actuelle",
      delete: {
        confirmation: "Êtes-vous sûr de vouloir supprimer cette version ?",
        success: "Version supprimée avec succès !",
      },
      validate: {
        confirmation: "Êtes-vous sûr de vouloir valider ce document ?",
        success: "Document validé avec succès !",
      },
      change: {
        title: "Demande de correction",
        success: "Demande de complément envoyée avec succès !",
        cancel: {
          confirmation: "Êtes-vous sûr de vouloir annuler cette demande de complément ?",
          success: "Demande de complément annulée avec succès !",
        },
      },
      verification: {
        title: "Vérifier les documents",
        modal: "Vérification",
        ask_modification: "Demande de modification",
        cancel_ask_modification: "Annuler la demande de complément",
        sign: "Viser le document",
      },
      empty: "Aucun fichier trouvé",
      error: "Une erreur est survenue dans l'affichage du pdf",
      uploaded: "Fichier déposé",
      generated: "Fichier généré",
      validation: {
        not_verify: "Le CERFA et la convention doivent être vérifiés pour valider cette étape",
      },
    },
    step: {
      in_progress: "Étape en cours",
      validation: {
        success: "Étape validée avec succès !",
      },
    },
    stamp: {
      action: "Mode tampon",
      stamped: { confirmed: "Document tamponné avec succès !" },
      cancel: "Quitter le mode tampon",
      tooltip: "Tamponner le pdf,\nle tampon apparaîtra,\nau centre du curseur\n(taille : 90x40 mm)",
      remove: {
        title: "Retirer le tampon",
        confirmation: "Êtes-vous sûr de vouloir retirer le tampon ?",
        success: "Tampon retiré avec succès",
      },
    },
    save: {
      success: "Votre fiche d'inscription a été enregistrée avec succès !",
    },
    resend_documents: {
      title: "Renvoyer les documents",
      confirmation: "Vous êtes sur le point de renvoyer les documents à l'entreprise {company}.",
      confirm: "Confirmer le renvoi",
      success: "Documents renvoyés à l'entreprise",
      no_document:
        "Vous devez archiver au moins un des deux documents déposés par l'entreprise pour les renvoyer en signature.",
    },
    request_changes: {
      title: "Demande de complément",
      confirmation: "Êtes-vous sûr de vouloir envoyer cette demande de complément ?",
      success: "Demande de complément envoyée avec succès !",
      recipients: "La demande de complément sera envoyée aux destinataires suivants :",
      requestAt: "Demande de complément effectuée le {date} par {validator}",
      cancel: {
        confirmation: "Êtes-vous sûr de vouloir annuler cette demande de complément ?",
        success: "Demande de complément annulée avec succès !",
      },
      new_submission: {
        confirmation: "Êtes-vous sûr de vouloir effectuer une nouvelle soumission du formulaire ?",
        success: "Formulaire soumis à nouveau avec succès !",
      },
    },
    contract_status: {
      init: "Initialisée",
      to_send_to_training_center: "À envoyer",
      sent_to_training_center: "Envoyée",
      validated_training_center: "Validée",
      signed: "Signée",
      error: "Erreur",
      archived: "Archivée",
    },
    download_training_sheet: "Télécharger la fiche information de la formation",
    ypareo: {
      title: "Yparéo",
      sync_button: "Synchroniser avec Yparéo",
      sync_success: "Dossier synchronisé avec Yparéo",
      sync_error: "Échec de la synchronisation Yparéo",
      running: "Synchronisation en cours…",
      error_indicator: "Erreur de synchronisation",
      synced_at: "Synchronisé le {date} (ID Yparéo {id})",
      resend_button: "Renvoyer",
      log_title: "Journal de synchronisation Yparéo",
      log_date: "Date",
      log_created: "Créé",
      log_updated: "Mis à jour",
      log_excluded: "Ignoré",
      log_errors: "Erreurs",
      log_empty: "Aucun journal disponible pour ce dossier.",
      error_tooltip: "Erreur de synchronisation Yparéo : {ypareo_sync_error}",
    },
    create: {
      confirmation: "Êtes-vous sûr de vouloir vous créer une nouvelle fiche de pré-inscription ?",
      alert: {
        confirm: "Accéder à votre fiche",
        cancel: "Créer une nouvelle fiche",
        multipleConfirm: "Accéder à vos fiches",
      },
    },
    contract: {
      title: "Contrat",
      see_more: "Voir plus",
      see_less: "Voir moins",
      empty: "Aucun contrat disponible",
      see: "Accéder au contrat",
      error: "Certaines informations ne sont pas correctes, veuillez les corriger sur la fiche d'inscription",
      synchronize: {
        confirm: "Êtes-vous sûr de vouloir synchroniser cet OPCO ?",
        success: "Synchronisation terminée avec succès !",
      },
      opco: {
        edit: {
          success: "Informations OPCO modifiées avec succès !",
        },
      },
      billing: {
        title: "Récapitulatif financier du contrat",
      },
    },
    empty_registation_list: "Aucune fiche de préinscription disponible",
    company_dashboard: {
      following_contract: {
        title: "Liste des contrats",
      },
    },
    opco_submission: {
      title: "Transmettre à l'OPCO",
      convention: "Convention",
      folder: "Dossier",
      confirmation: {
        title: "Confirmer la transmission à l'OPCO",
        subtitle: {
          title: "En envoyant le dossier à l'OPCO, le CFA :",
          li_1: "Atteste de l'exactitude des informations mentionnées dans la présente demande",
          li_2: "Atteste que les informations saisies dans le formulaire sont conformes aux informations du contrat conclu avec l'apprenti(e)",
          li_3: "Atteste que le CERFA est visé par l'organisme de formation responsable",
          li_4: "Atteste que le CERFA est signé par les parties (employeur, apprenti(e) et son représentant légal le cas échéant)",
          li_5: "S'engage à tenir les pièces justificatives à disposition des services de contrôle (OPCO, administration)",
        },
        confirm: "Confirmer l'envoi",
      },
      json: {
        title: "JSON envoyé à l'OPCO",
        see: "Voir le json envoyé",
        received: {
          title: "JSON reçu de l'OPCO",
          see: "Voir le json",
        },
      },
      success: {
        title: "Dossier transmis avec succès",
      },
      error: {
        title: "Échec de transmission",
      },
      response: {
        title: "Retour OPCO",
        message: "Message de retour",
      },
      status: {
        success: "Succès",
        in_progress: "En cours...",
        failed: "Échoué",
        waiting: "En attente d'envoi",
      },
      message: {
        processing: "En cours d'envoi",
      },
      manual: {
        alert:
          "L'employeur est responsable de la conclusion et de la transmission du contrat d'alternance (apprentissage ou professionnalisation) à son Opérateur de compétences (OPCO) ou à la DREETS pour les employeurs publics dès sa signature, et au plus tard dans les 5 jours ouvrables suivant le début du contrat. Ce dépôt est crucial pour déclencher les aides financières et assurer la couverture sociale.",
        success: "Envoi OPCO réalisé avec succès !",
      },
    },
    opco_folder: {
      send: {
        done: "Envoi Opco terminé",
      },
      last_sync: "Dernière synchro : {date}",
    },
    first_connexion: "Première connexion",
    params: {
      give_mandat: "Paramétrage mandat de gestion",
    },
    actor: {
      cfa: "CFA",
      ufa: "UFA",
      company: "Entreprise",
    },
    legal_responsible: {
      required: "Vous devez ajouter au moins un responsable légal (Maximum 2)",
      add: "Ajouter un responsable légal",
      add_second: "Ajouter un second responsable légal",
      edit: "Modifier un responsable légal",
      success_add: "Responsable légal ajouté avec succès !",
      success_edit: "Responsable légal modifié avec succès !",
      delete: {
        success: "Responsable légal supprimé avec succès !",
        confirmation: "Êtes-vous sûr de vouloir supprimer ce responsable légal ?",
      },
    },
    correction_requested: {
      title: "Demandes de modification",
      historic: "Historique des demandes de modification",
      creation: "Correction demandée par {creator} le {date}",
    },
    updated_cost: ({ plural, named }) => plural(["1 montant modifié", `${named("number")} montants modifiés`]),
    no_updated_cost: "Aucun montant modifié",
    amendment: "Avenant",
    mission: "Missions",
    salary: "Rémunération",
    financing_amount: "Tableau financier — Devis",
    invoice_tab: {
      title: "Financement/Facturation",
    },
    due_date: {
      valid: "Accepter les échéances OPCO",
      edit: "Modifier la répartition",
    },
    schedule: {
      title: "Échéancier",
      mode: {
        active: "Mode actif :",
        description: "OPCO = reçu via l'API Convergence, Manuel = modifié par le CFA",
        label: "Mode {mode}",
        confirmation: "Êtes-vous sûr de vouloir passer en mode {mode} ?",
        manual_warning:
          "Si vous basculez en mode manuel et que vous facturez une échéance :<br /><br />- Les factures ne seront plus transmissibles via API.<br />- Le mode « OPCO » ne sera plus accessible et vous devrez finaliser la facturation en mode manuel.",
      },
      empty: "Aucun échéancier pour le moment",
      legend: {
        title: "Légende des montants",
        invoiced: "Montant facturé",
        credited: "Montant total des avoirs",
        net: "Reste à facturer / net facturé",
      },
      error: "Une erreur est survenue lors du chargement de l'échéancier",
      type_unavailable: "Ce type d'échéancier n'est pas disponible pour ce contrat",
      column_installment: "Échéance",
      column_type: "Type",
      column_start_date: "Début",
      column_end_date: "Fin",
      column_amount: "Montant",
      type: {
        initial: "Initiale",
        intermediate: "Intermédiaire",
        balance: "Solde",
      },
      manual_edit: {
        edit_button: "Modifier la répartition manuelle",
        title: "Répartition manuelle des échéances",
        locked: "Échéance figée",
        locked_amount: "Montant de l'échéance {installment} (figée) : {amount}",
        locked_start_date: "Date de début de l'échéance {installment} (figée) : {date}",
        locked_end_date: "Date de fin de l'échéance {installment} (figée) : {date}",
        amount_label: "Montant de l'échéance {installment}",
        start_date_label: "Date de début de l'échéance {installment}",
        end_date_label: "Date de fin de l'échéance {installment}",
        add_line: "Ajouter une échéance",
        new_line: "Nouvelle échéance, non enregistrée",
        modified_line: "Échéance modifiée, non enregistrée",
        change: "{field} : {before} → {after}",
        deleted_line: "Échéance supprimée, non enregistrée",
        delete_line: "Supprimer l'échéance {installment}",
        delete_confirmation:
          "Supprimer cette échéance ? Son montant sera reporté sur l'échéance non figée la plus proche.",
        reset: "Réinitialiser",
        reset_confirmation:
          "Réinitialiser l'échéancier manuel ? Toutes les échéances non figées seront remplacées par le calcul automatique.",
        save: "Enregistrer",
        balance_target: "Montant net engagé",
        balance_current: "Total réparti",
        balance_gap: "Écart",
        balance_ok: "La somme des échéances correspond aux montants du dossier.",
        balance_error:
          "La somme des montants doit être égale au montant net engagé pour pouvoir ajouter une échéance ou enregistrer.",
        coverage_gap_error: "Les échéances ne couvrent pas tous les jours du contrat.",
        coverage_overlap_error: "Des échéances se chevauchent.",
        end_date_before_start_date: "La date de fin de cette échéance ne peut pas être antérieure à sa date de début.",
        start_date_out_of_pec_range:
          "La date de début de cette échéance doit être comprise entre le début de la prise en charge OPCO et le lendemain de sa fin.",
        end_date_exceeds_pec:
          "La date de fin de cette échéance ne peut pas dépasser le lendemain de la fin de prise en charge OPCO.",
        date_conflict: "Cette date crée un trou ou un chevauchement entre les échéances",
        show_line_errors: "Afficher les erreurs de dates de l'échéance {installment}",
        show_all_line_errors: "Afficher les erreurs",
        hide_all_line_errors: "Masquer les erreurs",
        lines_with_date_errors:
          "{count} échéance contient des erreurs de dates : utilisez l'icône d'alerte de la ligne pour en voir le détail. | {count} échéances contiennent des erreurs de dates : utilisez l'icône d'alerte de chaque ligne pour en voir le détail.",
        unsaved_changes: "Des modifications n'ont pas été enregistrées. Voulez-vous les enregistrer avant de fermer ?",
        discard: "Ne pas enregistrer",
        unbalanced_changes:
          "La somme des échéances ne correspond pas aux montants du dossier : vos modifications ne peuvent pas être enregistrées et seront perdues. Fermer quand même ?",
        invalid_coverage_changes:
          "Les échéances ne couvrent pas correctement la période du contrat : vos modifications ne peuvent pas être enregistrées et seront perdues. Fermer quand même ?",
        invalid_date_changes:
          "Certaines dates de l'échéancier sont invalides : vos modifications ne peuvent pas être enregistrées et seront perdues. Fermer quand même ?",
        close_anyway: "Fermer",
        continue_editing: "Continuer la saisie",
        saved: "Répartition manuelle enregistrée",
        error: "Une erreur est survenue lors de la mise à jour de la répartition manuelle",
      },
    },
    export: {
      workflow: "Export des inscriptions (flux)",
      contract_data: "Export des contrats",
      missions: "Exporter les missions",
      financial: "Export financier",
    },
  },
};
